import { TableCell } from '@material-ui/core';

import { useRouteRef } from '@backstage/core-plugin-api';

import { LabelChips, useLabelFilters } from '@spotify/confidence-common-react';
import {
  extractLastNameComponentFromName,
  extractWorkflowFromInstanceName,
  formatDatePast,
} from '@spotify/confidence-core-react';
import { getTypeOrNull } from '@spotify/confidence-graphql';

import { WorkflowInstanceListItem } from '../../hooks/useListWorkflowInstances';
import { useStateCell } from '../../hooks/useStateCell';
import { workflowInstanceRouteRef } from '../../routes';
import { IconPlaceholder, NameCell } from '../NameCell';
import { OwnerCell } from '../OwnerCell';
import { StateCell } from '../StateCell';
import { UpdateCell } from '../UpdateCell';
import { WorkflowInstanceTableRow } from '../WorkflowInstanceTableRow';

export const DefaultWorkflowTableRow = ({
  workflowInstance,
  kind = 'Experiment',
  icon,
}: {
  kind?: string;
  workflowInstance: WorkflowInstanceListItem;
  icon?: React.ReactNode;
}) => {
  const workflowInstanceRoute = useRouteRef(workflowInstanceRouteRef);
  const href = workflowInstanceRoute({
    workflow: extractWorkflowFromInstanceName(workflowInstance.name) ?? '',
    id: extractLastNameComponentFromName(workflowInstance.name),
  });
  const stateProps = useStateCell(workflowInstance);
  const { toggleLabelFilter, labelDefinitions } = useLabelFilters();
  const hasLabels = labelDefinitions.length > 0;

  const secondaryText =
    workflowInstance.state === 'draft'
      ? `Created ${formatDatePast(new Date(workflowInstance.createTime))}`
      : `Updated ${formatDatePast(new Date(workflowInstance.updateTime))}`;

  return (
    <WorkflowInstanceTableRow workflowInstance={workflowInstance}>
      <NameCell
        kind={kind}
        displayName={workflowInstance.displayName}
        comments={getTypeOrNull(workflowInstance.comments)}
        icon={icon ?? <IconPlaceholder />}
        secondaryText={secondaryText}
        href={href}
        labels={workflowInstance.labels}
       data-track-source-anchor="5898b3e82e;default-workflow-table-row-name-cell"/>
      <StateCell {...stateProps} />
      <TableCell />
      <UpdateCell updateTime={workflowInstance.updateTime} />
      <OwnerCell owner={getTypeOrNull(workflowInstance.owner)} />
      {hasLabels && (
        <TableCell>
          <LabelChips
            labels={workflowInstance.labels}
            labelDefinitions={labelDefinitions}
            onLabelClick={toggleLabelFilter}
          />
        </TableCell>
      )}
    </WorkflowInstanceTableRow>
  );
};
